import { FC, PropsWithChildren, useMemo } from 'react';

import { RequestConfig } from '~/common/services/requests';
import { useMe } from '../../api/authentication';
import { useAuthData } from '../AuthContext/hooks/useAuthData';
import { UserContext } from './UserContext';

type UserProviderProps = PropsWithChildren<{
  params?: RequestConfig['params'];
}>;

export const UserProvider: FC<UserProviderProps> = ({ params, children }) => {
  const authData = useAuthData();

  const {
    me: user,
    isLoading,
    refetch,
  } = useMe({
    params,
    enabled: !!authData?.jwt,
  });

  const value = useMemo(
    () => ({ user: user ?? null, isLoading, refetch }),
    [user, isLoading, refetch],
  );

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
